<template>
  <div class="card mb-3">
    <div class="card-body">
      <div class="card-title d-flex align-items-center">
        <strong>API Request #{{id}}</strong>
        <router-link :to="referrer.fullPath" class="btn btn-link btn-sm ml-auto">Back</router-link>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered table-layout-fixed">
          <tbody>
            <tr>
              <th>API</th>
              <td>{{ apiRequest.api_name }}</td>
            </tr>
            <tr>
              <th>Client</th>
              <td>{{ apiRequest.provider }}</td>
            </tr>
            <tr>
              <th>Callback URL</th>
              <td>
                <textarea class="form-control" :value="apiRequest.return_url" readonly v-autosize />
              </td>
            </tr>
            <tr>
              <th>Parameters</th>
              <td>
                <textarea class="form-control" :value="parameters" readonly v-autosize  />
              </td>
            </tr>
            <tr>
              <th>Payload</th>
              <td>
                <textarea class="form-control" :value="apiRequest.payload" readonly v-autosize />
              </td>
            </tr>
            <tr>
              <th>Status</th>
              <td>{{ apiRequest.status }}</td>
            </tr>
            <tr>
              <th>Response Body</th>
              <td>
                <textarea class="form-control" :value="apiRequest.response_body" readonly v-autosize />
              </td>
            </tr>
            <tr>
              <th>Parsed Response</th>
              <td>
                <textarea class="form-control" :value="parsedResponse" readonly v-autosize />
              </td>
            </tr>
            <tr>
              <th>Response Error</th>
              <td>
                <textarea class="form-control" :value="responseError" readonly v-autosize />
              </td>
            </tr>
            <tr>
              <th>Callback Response</th>
              <td>
                <textarea class="form-control" :value="apiRequest.return_url_response" readonly v-autosize />
              </td>
            </tr>
            <tr>
              <th>Callback Status</th>
              <td>{{ apiRequest.return_url_response_status_code }}</td>
            </tr>
            <tr>
              <th>JOB ID</th>
              <td>{{ apiRequest.job_id }}</td>
            </tr>
            <tr>
              <th>Created At</th>
              <td>{{ apiRequest.created_at | moment("DD MMM YYYY HH:mm:ss") }}</td>
            </tr>
            <tr>
              <th>Updated At</th>
              <td>{{ apiRequest.updated_at | moment("DD MMM YYYY HH:mm:ss") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  props: ["id"],

  data() {
    return {
      isLoading: false,
      apiRequest: {}
    };
  },

  computed: {
    ...mapState(["referrer"]),

    parameters() {
      return this.$options.filters.prettyJSON(this.apiRequest.parameters);
    },

    parsedResponse() {
      return this.$options.filters.prettyJSON(this.apiRequest.parsed_response);
    },

    responseError() {
      return this.$options.filters.prettyJSON(this.apiRequest.response_error);
    }
  },

  filters: {
    prettyJSON(value) {
      if (value && typeof value === "object") {
        return JSON.stringify(value, null, 2);
      } else {
        return value;
      }
    }
  },

  methods: {
    async fetchApiRequest() {
      this.isLoading = true;
      try {
        const { data } = await axios.get(`/api/api_requests/${this.id}`);
        console.log("Response", data)
        //this.apiRequest = data.data.attributes;
        this.apiRequest = data;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    }
  },

  beforeMount() {
    this.fetchApiRequest();
  }
};
</script>

<style scoped>
th {
  background-color: #f8f9fa;
  width: 220px;
  vertical-align: top !important;
}

textarea.form-control {
  min-height: 38px;
  max-height: 200px;
  resize: vertical;
}
</style>
